import { FC, useState } from "react";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import styles from "./SavingTemplate.module.sass";
import { MyInput } from "../../MyInput/MyInput";
import { MyTextarea } from "../../MyTextarea/MyTextarea";
import { useParams } from "react-router-dom";
import {organizationAPI} from "libs/apiClient/Organization";

interface SavingTemplateProps {
	close: () => void;
}

export const SavingTemplate: FC<SavingTemplateProps> = ({ close }) => {
	const [name, setName] = useState<string>("");
	const [comment, setComment] = useState<string>("");
	const [submitError, setSubmitError] = useState<boolean>(false);

	const params = useParams();

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		console.log(params);
		e.preventDefault();
		if (!name.trim()) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			organizationAPI.processesPatternCreate( {
					bpIdsList: [],
					comment,
					name,
				}, params.organizationId!)
				.then((r) => {
					const { patternId } = r.data;
					organizationAPI.processesDetail(+params.organizationId!).then((r) => {
						const bpIdsList = r.data.map((_) => _.id);
						organizationAPI.processesPatternImportBpsCreate(patternId, {bpIdsList},+params.organizationId!)
							.then(() => {
								close();
							});
					});
				})
				.catch(() => {
					setSubmitError(true);
					setTimeout(() => {
						setSubmitError(false);
					}, 3000);
				});
		}
	};

	return (
		<section className={styles.wrp}>
			<div className={styles.header}>
				<h4 className={styles.title}>Сохранение шаблона реестра БП</h4>
				<span className={styles.subtitle}>Придумайте название шаблону и комментарий если нужно.</span>
			</div>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles["form-wrp"]}>
					<div className={styles.item}>
						<MyInput
							className={styles.item}
							required={true}
							warning={{ condition: submitError, text: "Такое имя существует" }}
							condition={submitError || (submitError && !comment.trim())}
							name="Название шаблона"
							placeholder={"Полное название"}
							value={name}
							set={(e) => {
								setName(e.target.value);
							}}
							maxLength={50}
						/>
					</div>
					<div className={styles.item}>
						<MyTextarea
							value={comment}
							set={(e) => setComment(e.target.value)}
							name="Комментарий"
							placeholder="Введите текст"
							width="full"
							maxLength={200}
						/>
					</div>
				</div>
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отменить
					</Button>
					<Button type="submit" className={styles.button}>
						Готово
					</Button>
				</div>
			</form>
		</section>
	);
};
